import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import moment from 'moment';
import helpers from '../../mixins/helpers';

const state = {
    ordenes: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-60, 'days').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).format('YYYY-MM-DD'),
    cliente: null,

    ordenesACotizar: [],
    resultados: [],

    deleted: false,
};

const mutations = {
    updateField,

    'INICIALIZAR_ORDENES' (state) {
        state.ordenes = [];
    },
    'SET_ORDENES' (state, ordenes) {
        state.ordenes = ordenes;
    },
    'PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
    'DELETED'(state, deleted) {
        state.deleted = deleted;
    },

    'INICIALIZAR_ORDENES_A_COTIZAR' (state) {
        state.ordenesACotizar = [];
    },
    'SET_ORDENES_A_COTIZAR' (state, ordenesACotizar) {
        state.ordenesACotizar = ordenesACotizar;
    },
    'INICIALIZAR_RESULTADOS' (state) {
        state.resultados = [];
    },
    'SET_RESULTADOS' (state, resultados) {
        state.resultados = resultados;
    },
};

const getters = {
    getField,
    ordenes (state) {
        return state.ordenes;
    },
    ordenesACotizar (state) {
        return state.ordenesACotizar;
    },
    resultados (state) {
        return state.resultados;
    },
    deleted (state) {
        return state.deleted;
    },
};

const actions = {
    getOrdenesTrabajo ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDENES');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
                + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD')
                + '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            
            if (state.cliente) {
                if (state.cliente.id != 0) {
                    queryString += '&clienteId=' + state.cliente.id;
                }
            }
            /*
            if (state.accion) {
                if (state.accion.id != 0) {
                    queryString += '&accionId=' + state.accion.id;
                }
            }
            */

            apiAxios.get('ordenestrabajos' + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('PAGINATION', params);
                    }

                    commit('SET_ORDENES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getOrdenesTrabajoACotizar ( { commit } ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_ORDENES_A_COTIZAR');

            apiAxios.get('ordenestrabajos/cotizar')
                .then(res => {
                    commit('SET_ORDENES_A_COTIZAR', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        }, error => {
            reject(error);
        })            
    },
    getOrdenesRentabilidadNegativa ( { commit }, params ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR_RESULTADOS');

            let queryString = '?fechaDesde=' + moment(params.fechaDesde).format("YYYY-MM-DD")
                +  '&fechaHasta=' + moment(params.fechaHasta).format("YYYY-MM-DD")

            apiAxios.get('ordenestrabajos/rpt/rentabilidad-negativa' + queryString)
                .then(res => {
                    commit('SET_RESULTADOS', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })
    },

};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}